var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _rect16, _rect17, _rect18, _rect19, _path5, _rect20, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 62,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 62,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 77C25 68.7157 31.7157 62 40 62V77H25Z",
    fill: "#00AE84"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 77,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 107C85 98.7157 91.7157 92 100 92V107H85Z",
    fill: "#00AE84"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 92,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 92C168.284 92 175 98.7157 175 107H160V92Z",
    fill: "#00AE84"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 77,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 62.5,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 107,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 107,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 107,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 107,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 122H130C130 130.284 123.284 137 115 137V122Z",
    fill: "#00AE84"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 122,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 122,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 122,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 122,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 122H40V137C31.7157 137 25 130.284 25 122Z",
    fill: "#00AE84"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 122,
    width: 15,
    height: 15,
    fill: "#00AE84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77C76.7157 77 70 83.7157 70 92H85V77Z",
    fill: "#00AE84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.82cdaf9a1a350d68e71fa11b615d02c4.svg";
export { ForwardRef as ReactComponent };